import { Document, Entry, ILink, IProgressIndicator, IRichText } from '@belong/types';
import { FLink, IEntryLink } from '../elements';
import { parseFlexibleContent } from '../parseFlexibleContent';
import { FRichText } from '../richText.factory';

interface IEntryMoleculeProgressIndicatorState extends Required<
  Pick<IProgressIndicator, 'statusIcon' | 'statusTagColour' | 'statusLabel'>
> {
  key?: string;
  cta?: Entry<IEntryLink>;
  content: Document;
}

export interface IMoleculeProgressIndicatorState extends Omit<
  IEntryMoleculeProgressIndicatorState,
  'key' | 'cta' | 'content'
> {
  cta?: ILink;
  content?: IRichText;
}

const FMoleculeProgressIndicatorState = (
  data: Entry<IEntryMoleculeProgressIndicatorState>
): IMoleculeProgressIndicatorState => {
  const { content, cta, key, ...otherFields } = data.fields;
  return {
    cta: cta && FLink(cta),
    content: content && FRichText(content),
    ...otherFields
  };
};

const flexibleContentMap = new Map([['moleculeProgressIndicatorState', { factory: FMoleculeProgressIndicatorState }]]);

interface IEntryMoleculeProgressIndicator {
  key?: string;
  heading: string;
  states: Entry<IEntryMoleculeProgressIndicatorState>[];
}

export interface IMoleculeProgressIndicator<T extends string = string> {
  heading: string;
  states: Record<T, IMoleculeProgressIndicatorState>;
}

export const FMoleculeProgressIndicator = (data: Entry<IEntryMoleculeProgressIndicator>) => {
  const { heading, states } = data.fields;
  return {
    heading,
    states: parseFlexibleContent(states, flexibleContentMap)
  };
};
